<template>
  <component :is="getComponent()"></component>
</template>

<script>
import { mapGetters } from "vuex";
import EventsTickets from "~/components/events/views/EventsTickets";
import EventsOrders from "~/components/events/views/EventsOrders";

export default {
  name: "EventsList",
  components: {
    EventsTickets,
    EventsOrders,
  },
  computed: {
    ...mapGetters(["ticketFilter"]),
  },
  methods: {
    getComponent() {
      if (this.ticketFilter === "ordersRecap") {
        return "EventsOrders";
      }
      return "EventsTickets";
    },
  },
};
</script>

<style lang="scss"></style>
